'use client';

import { ISalePageDetailResponse } from '@/api/types';
import { Carousel } from '@/components/carousel';
import { Element, ElementProps } from '@vuddy/components';
import { isNonNil, jsonAssignInlineVars } from '@vuddy/utils';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { TopImage } from './TopImage';
import * as styles from './topImages.css';
import { TopVideo } from './TopVideo';

interface SalePageTopImagesProps {
  salePage?: Partial<ISalePageDetailResponse>;
  backgroundColor?: ElementProps['backgroundColor'];
}

export const SalePageTopImages = ({
  salePage,
  backgroundColor,
}: SalePageTopImagesProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isGacha = salePage?.type === 'GACHA';
  const isClass = salePage?.type === 'CLASS';

  return (
    <Element
      className={styles.wrapper({ isGacha, isClass })}
      backgroundColor={backgroundColor}>
      <Element className={styles.carouselWrapper({ isClass })}>
        <Carousel onChange={setActiveIndex} paddingX="0">
          {isEmpty(salePage?.additionalImages) ? (
            <Element className={styles.imageWrapper({ isClass })}>
              <Skeleton height="100%" />
            </Element>
          ) : (
            salePage?.additionalImages?.map(additionalImage => (
              <Element
                key={additionalImage.uuid}
                className={styles.imageWrapper({ isClass })}
                style={
                  isClass && additionalImage.type === 'IMAGE'
                    ? jsonAssignInlineVars({
                        [styles.desktopBackgroundImage]: `url(${additionalImage.url})`,
                      })
                    : undefined
                }>
                {isClass ? (
                  <>
                    <div className={styles.backdropOverlay} />
                    <div className={styles.imageContainer}>
                      {additionalImage.type === 'IMAGE' ? (
                        <TopImage
                          additionalImage={additionalImage}
                          alt={salePage.name ?? ''}
                          isClass={isClass}
                        />
                      ) : (
                        <TopVideo additionalImage={additionalImage} />
                      )}
                    </div>
                  </>
                ) : additionalImage.type === 'IMAGE' ? (
                  <TopImage
                    additionalImage={additionalImage}
                    alt={salePage.name ?? ''}
                    isClass={isClass}
                  />
                ) : (
                  <TopVideo additionalImage={additionalImage} />
                )}
              </Element>
            ))
          )}
        </Carousel>
        {isNonNil(salePage) && (salePage.additionalImages?.length ?? 0) > 1 && (
          <div
            className={styles.indicator}
            style={jsonAssignInlineVars({
              [styles.indicatorTop]: isGacha ? '52px' : undefined,
              [styles.indicatorBottom]: isGacha ? undefined : '12px',
              [styles.indicatorLeft]: isGacha ? undefined : undefined,
              [styles.indicatorRight]: isGacha ? '16px' : '12px',
            })}>
            {activeIndex + 1}/{salePage.additionalImages?.length}
          </div>
        )}
      </Element>
    </Element>
  );
};
